import { render, staticRenderFns } from "./nice-stats-value.vue?vue&type=template&id=630b48bc&scoped=true"
import script from "./nice-stats-value.vue?vue&type=script&lang=js"
export * from "./nice-stats-value.vue?vue&type=script&lang=js"
import style0 from "./nice-stats-value.vue?vue&type=style&index=0&id=630b48bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b48bc",
  null
  
)

export default component.exports